// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"854":"92b93e0f","2291":"95492aae","2907":"6a214574","4053":"8e8cc97c","9151":"f729d96d"}[chunkId] + ".chunk.css";
};